<app-header
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>

<div class="container page-container">
  <img src="imgs/icon.png" class="logo-icon" alt="MyMindLog icon">
  <div class="sub-title">{{ 'appointments-report.title' | translate }}</div>

  <div class="form-container report-form-container">
    <form [formGroup]="reportForm" class="form">
      <p class="label">{{ 'labels.patient' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="patientControl" (openedChange)="onPatientSelectOpened($event)">
          <mat-option disabled class="patient-search-option">
            <input
              #patientSearchInput
              matInput
              type="text"
              [value]="patientSearchTerm()"
              [placeholder]="'placeholders.search_patient' | translate"
              autocomplete="off"
              class="patient-search-input"
              (mousedown)="$event.stopPropagation()"
              (input)="onPatientSearch($event)"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()">
          </mat-option>
          @for (item of filteredPatients(); track item.id) {
            <mat-option [value]="item.id">{{item.first_name + ' ' + item.last_name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (
        patientControl.invalid
        && patientControl.errors
        && (patientControl.touched || patientControl.dirty)
      ) {
        <div class="error">
          {{ 'errors.field_required' | translate }}
        </div>
      }

      <app-input
        [label]="'appointments-report.start_date' | translate"
        [formControl]="startDateControl"
        type="date">
      </app-input>

      <app-input
        [label]="'appointments-report.end_date' | translate"
        [formControl]="endDateControl"
        type="date">
      </app-input>

      <div class="comments-field">
        <app-text-area
          [label]="'appointments-report.comments' | translate"
          [control]="commentsControl">
        </app-text-area>
      </div>

      @if (dateRangeError()) {
        <div class="error date-range-error">
          {{ getDateRangeErrorKey() | translate }}
        </div>
      }

      @if (!loadingPatients() && !hasPatients()) {
        <div class="info-message">{{ 'appointments-report.no_patients' | translate }}</div>
      }

      <div class="actions-container top-actions">
        <app-button
          [buttonLabel]="'appointments-report.generate' | translate"
          [buttonType]="BUTTON_TYPES.REGULAR"
          [buttonDisabled]="isGenerateDisabled()"
          (click)="generateReport()">
        </app-button>
      </div>
    </form>
  </div>
</div>

@if (isProcessing()) {
  <div class="loading-overlay">
    <app-loading></app-loading>
  </div>
}
